import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API


export const getCausa = (setCausas, modulo) => {
    api.get(`${apiUrl}/monitor/getCausa?modulo=${modulo}`)
        .then((res) => {
            setCausas(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getEfectos = (setEfectos, id_causa) => {
    api.get(`${apiUrl}/monitor/getEfectos?id_causa=${id_causa}`)
        .then((res) => {
            setEfectos(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getIncidente = async (setGetIncidente, bitacora) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    await api.get(`${apiUrl}/monitor/incidente/getIncidente?id_bitacora=${bitacora}`)
        .then((res) => {
            Swal.close();
            setGetIncidente(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTiempoBitacora = (setGetTiempo, bitacora) => {
    api.get(`${apiUrl}/monitor/bitacoras/get/time?id_bitacora=${bitacora}`)
        .then((res) => {
            setGetTiempo(res.data)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const updateIncidente = async (data, setEditarIncidente) => {
    await api.patch(`${apiUrl}/monitor/incidente/edit`, data)
        .then((res) => {
            // setGetIncidente(res.data)
            Swal.close();
            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Actualizado correctamente', // Título de la alerta
            });
            setEditarIncidente(null)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const resistrarIncidente = async (data, setShowCrearIncidente, limpiarDatos) => {
    return await api.post(`${apiUrl}/monitor/incidente/add`, data)
        .then((res) => {







            if (res.data.message) {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: res.data.message,
                    confirmButtonText: 'OK'
                });
                return false;
            }
            else {
                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: `Registrado correctamente  -----  ID de incidente : ${res.data[0].ID_GENERADO}`,
                });
                limpiarDatos();
                return true;
            }



        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const updateTime = (data, setShowCambiarHora) => {
    api.patch(`${apiUrl}/monitor/bitacoras/update/time`, data)
        .then((res) => {

            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Actualizado correctamente', // Título de la alerta
            });
            setShowCambiarHora(null)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const cancelarServicio = (data, setShowCancelarServicio) => {
    Swal.fire({
        title: '¿Estás seguro?',
        text: 'Escribe "CANCELAR" para confirmar la cancelación del servicio. (si cancela no se le pagara al operador.)',
        input: 'text',
        inputPlaceholder: 'Escribe CANCELAR aquí',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
            if (value.trim().toUpperCase() !== 'CANCELAR') {
                return 'Debes escribir exactamente "CANCELAR" para continuar.';
            }
            return null;
        }
    }).then((result) => {
        if (result.isConfirmed) {
            api.post(`${apiUrl}/monitor/bitacoras/cancelar`, data)
                .then((res) => {
                    const message = res.data?.message;

                    if (message) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: message,
                        });
                    } else {
                        Swal.fire({
                            icon: 'success',
                            title: 'Actualizado correctamente',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        setShowCancelarServicio(null);
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrió un error',
                        text: error.response?.data?.message || 'No se pudo completar la operación',
                    });
                });
        }
    });
}
export const desconfirmar = (data, setShowDesconfirmarBitacora) => {
    api.post(`${apiUrl}/monitor/bitacoras/desconfirmar`, data)
        .then((res) => {
            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Actualizado correctamente', // Título de la alerta
            });
            setShowDesconfirmarBitacora(null)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getCancelados = (id_bitacora, setCancelados) => {
    api.get(`${apiUrl}/monitor/bitacora/getCancelado?id_bitacora=${id_bitacora}`)
        .then((res) => {
            setCancelados(res.data)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const registrarNota = async (nuevaNota) => {
    try {

        const response = await api.post(`${apiUrl}/monitor//bitacoras/add-notas`, nuevaNota)
        return response.data
    }
    catch (error) {
        throw error
    }
}
export const getNotas = async (id_bitacora) => {
    try {

        const response = await api.get(`${apiUrl}/monitor/bitacoras/get-notas?id_bitacora=${id_bitacora}`)
        return response.data
    }
    catch (error) {
        throw error
    }
}
export const revisarNota = async (idNota, revisado, id_usuario) => {
    try {
        const params = {
            id_nota: idNota,
            revisado: revisado ? 1 : 0,
            id_usuario: id_usuario
        }
        const response = await api.patch(`${apiUrl}/monitor/bitacoras/revisar-nota`, params)
        return response.data
    }
    catch (error) {
        throw error
    }
}
